<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>

<body>
  <div class="tituloEpesquisa">
    <h1 class="subtitulo"
      style="font-family: 'Times New Roman', Times, serif; text-align: center; flex: 1; margin: 10px;"> {{ tituloPagina
      }}
    </h1>

  </div>
  <div class="headerContratos">
    <div class="align-left search">
      <!-- <div class="pesquisa"> -->
      <!-- <h2>Filtrar Periodo</h2> -->
      <!-- <input #dateInput type="date" class="dateInput" id="startDate" [(ngModel)]="startDateFilter">
        <input #dateInput2 type="date" class="dateInput" id="endDate" [(ngModel)]="endDateFilter">
        <button class="inputDate" (click)="applyFilter()">Filtrar data</button>
        <button class="inputDate" (click)="clearFilter()">Limpar filtro</button> -->
      <!-- </div> -->
      <!-- <div class="pesquisa">
        <h2>Baixar registros de outros períodos</h2>-->
      <input #dateInput3 type="date" class="dateInput" id="startDateIni" [(ngModel)]="startDateIni">
      <input #dateInput4 type="date" class="dateInput" id="endDateIni" [(ngModel)]="endDateIni">
      <button class="inputDate" (click)="filtroAtivado = true; getItemsFromDynamoDBComData()">Atualizar</button>
      <button class="inputDate" (click)="clearFilter()">Limpar filtro</button>

      <!-- </div>  -->
    </div>

    <div class="align-right">
      <!-- <button class="btn-frete" mat-button (click)=" editDialog(items)">
        <span class="material-icons">note_add</span> Solicitar Frete Extra
      </button>
      <button class="btn-frete" mat-button (click)="exportToExcel(items)">
        <span class="material-icons">print</span> Print
      </button> -->
      <div class="icone-setting">
        <input name="filtro" type="text" style="flex: 1;" [(ngModel)]="searchString" (keyup)="aplicarFiltro()"
          placeholder="filtrar palavras">
        <div class="icone-setting">
          <!-- <i-feather name="file-plus"></i-feather> -->
          <button class="btn-frete icone-setting" mat-button (click)="solicitarFrete()"><i-feather
              name="file-plus"></i-feather>Solicitar Frete Extra</button>
        </div>
        <div class="icone-setting">
          <!-- <i-feather name="printer"></i-feather> -->
          <button [disabled]="!isCarrierEnabled && !isAdminEnabled" class="btn-frete icone-setting" mat-button
            (click)="exportToExcel(items)"><i-feather name="printer"></i-feather>Print</button>
          <button [disabled]="!isCarrierEnabled && !isAdminEnabled" class="btn-frete icone-setting" mat-button
            (click)="exportToExcel(itemsIncluindoFinalizados)"><i-feather name="printer"></i-feather>Print All
            Items</button>
        </div>
      </div>
    </div>
  </div>
  <ul>
    <table id="excel-table">
      <thead>
        <tr class="header-row">
          <td><label>ID</label></td>
          <td><label>Data</label></td>
          <td><label>Data Coleta</label></td>
          <td><label>Origem</label></td>
          <td><label>Endereço Coleta</label></td>
          <td><label>Destino</label></td>
          <td><label>Endereço Destino</label></td>
          <td><label>Data entrega</label></td>
          <td><label>Distância</label></td>
          <td><label>Frete</label></td>
          <td><label>Requisitante</label></td>
          <!-- <td><label>Transportador</label></td> -->
          <!-- <td><label>Veículo Disponível</label></td> -->
          <td><label>Veículo Requisitado</label></td>
          <td><label>Placa</label></td>
          <td><label>Tipo</label></td>
          <td><label>Status</label></td>
          <td><label>Ações</label></td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filtereditems" [class]="getStatusClass(item.status)">
          <td>{{ item.ID }}</td>
          <td>{{ item.date | date:'dd-MM-yy'}}</td>
          <td>{{ item.datePickup | date:'dd-MM-yy' + " " + item.timePickup }}</td>
          <td>{{ (item.locationPickup == "other" ? item.otherLocationPickup : item.locationPickup) + (item.areaPickup ?
            " - " + item.areaPickup : "")}}</td>
          <td>{{ item.addressPickup + (item.numberPickup ? " - " + item.numberPickup : "") + (item.cityPickup ? " - " +
            item.cityPickup : "") + (item.statePickup ? " - " +
            item.statePickup : "")}}</td>
          <td>{{ (item.locationDelivery == "other" ? item.otherLocationDelivery : item.locationDelivery) +
            (item.areaDelivery ? " - " + item.areaDelivery : "")}}</td>
          <td>{{ item.addressDelivery + (item.numberDelivery ? " - " + item.numberDelivery : "") + (item.cityDelivery ?
            " - " + item.cityDelivery : "") + (item.stateDelivery ? " -
            " + item.stateDelivery : "") }}</td>
          <td>{{ item.dateDelivery | date:'dd-MM-yy' + " " + item.timeDelivery }}</td>
          <td>{{ item.distancia | number:'1.1-1' }}</td>
          <td>{{ item.freteCalculado | currency:'BRL':'symbol':'1.2-2' }}</td>
          <td>{{ item.reqName + " - " + item.reqId}}</td>
          <!-- <td>{{ item.carrier}}</td> -->
          <!-- <td>{{ item.vehicleType}}</td> -->
          <td>{{ item.reqVehicle}}</td>
          <td>{{ item.plate}}</td>
          <td>{{ item.tipo}}</td>
          <td>{{ item.status}}</td>
          <td class="action-buttons">
            <button [disabled]="!isCarrierEnabled && !isAdminEnabled" mat-icon-button color="primary"
              aria-label="Editar" (click)="editDialog(item)">
              <span class="material-icons">edit</span>
            </button>
            <button [disabled]="usuarioLogado.role != '9' && usuarioLogado.role != '2'" mat-icon-button color="warn"
              aria-label="Excluir" (click)="deleteItem(item.ID, urlConsulta, query)">
              <span class="material-icons">delete</span>
            </button>
            <button mat-icon-button color="warn" aria-label="Print" (click)="addImageToExcel(item)">
              <span class="material-icons">print</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </ul>
</body>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
  <!-- <div> -->
  <h3 class="modal-title">Solicitação de Frete Extra</h3>
  <h3 class="modal-title" style="font-size: 15px;">Contact: <abbr style="color: #3b82f6; font-size: 15px;">{{ ssbResp }}</abbr>
    Phone: 55 11 {{ telefoneFixoResp}} | Mobile: +55 11
    {{telefoneCelularResp}} </h3>
  <!-- </div> -->
  <div class="modal-body scroll-container">
    <form class="inputs">
      <table class="table2000">
        <tr *ngIf="usuarioLogado">
          <td [class]="getStatusClass(item.status)" class="camposLabels selectStatus">
            <H2>{{ item.status }}</H2>
          </td>
          <td class="camposLabels selectStatus"
            *ngIf="(usuarioLogado.role ==  '9' || usuarioLogado.role ==  '2') && item.status == 'Reject'">
            <button type="button" label="requested" (click)="item.status = 'Requested'">REQUISITADO</button>
          </td>
          <td class="camposLabels selectStatus"
            *ngIf="item.status == 'Requested'  && (usuarioLogado.role == '3' || usuarioLogado.role ==  '9' || usuarioLogado.role ==  '2')">
            <button type="button" label="Accept" (click)="item.status = 'Planned'">ACEITAR</button>
          </td>
          <td class="camposLabels selectStatus"
            *ngIf="item.status == 'Requested'  && (usuarioLogado.role == '3' || usuarioLogado.role ==  '9' || usuarioLogado.role ==  '2')">
            <button type="button" label="reject" (click)="item.status = 'Reject'">REJEITAR</button>
          </td>
          <td class="camposLabels selectStatus"
            *ngIf="(usuarioLogado.role ==  '9' || usuarioLogado.role ==  '2') && item.status != 'Completed' && item.status != 'Canceled' && item.status != 'NOVA SOLICITAÇÃO'">
            <button type="button" label="cancel" (click)="item.status = 'Canceled'">CANCELAR</button>
          </td>
          <td class="camposLabels selectStatus"
            *ngIf="(item.status == 'Planned' && (usuarioLogado.role == '3' || usuarioLogado.role ==  '9' || usuarioLogado.role ==  '2'))">
            <button type="button" label="executing" (click)="item.status = 'Executing'">EXECUTANDO</button>
          </td>
          <td class="camposLabels selectStatus"
            *ngIf="item.status == 'Executing' && (usuarioLogado.role == '3' || usuarioLogado.role ==  '9' || usuarioLogado.role ==  '2')">
            <button type="button" label="completed" (click)="finalizarViagem(item)">FINALIZADA</button>
          </td>
        </tr>
        <tr>
          <td>
            <label class="modal-label">Motivo da solicitação</label>
            <!-- </td>
          <td class="align-left input-maior"> -->
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="motive" [(ngModel)]="item.motive"
              class="modal-input0" [required]="true">
          </td>
          <td>
            <label class="modal-label">Descrição do Material</label>
            <!-- </td>
          <!-- <td class="align-left input-maior">
            <input type="text" name="description" [(ngModel)]="item.description" class="modal-input0">
          </td> --
          <td class="align-left input-maior"> -->
            <input type="text" name="description" [(ngModel)]="item.description" class="modal-input0"
              (input)="verificarCaracteresEspeciais()">
            <div *ngIf="temCaracterEspecial">
              <small class="text-danger">Não utilize caracteres especiais</small>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <label class="modal-label">Numero da NF</label>
            <!-- </td>
          <td> -->
            <input type="text" name="nf" [(ngModel)]="item.nf" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">Valor total da NF</label>
            <!-- </td>
          <td> -->
            <input type="text" name="nfTotal" [(ngModel)]="item.nfTotal" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">Valor do Frete</label>
            <!-- </td>
          <td> -->
            <input type="text" name="totalCost" [(ngModel)]="item.totalCost" class="modal-input1">
          </td>
          <!-- </tr>
        <tr> -->
          <td>
            <label class="modal-label">Peso (Kg)</label>
            <!-- </td>
          <td> -->
            <input type="text" name="weight" [(ngModel)]="item.weight" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">Quantidade</label>
            <!-- </td>
          <td> -->
            <input type="text" name="quantity" [(ngModel)]="item.quantity" class="modal-input1">
          </td>
        </tr>
        <tr>
          <!-- <td class="selectStatus">
            <label class="modal-label">Transport.</label>
            <select [disabled]="!isAdminEnabled" class="selectVehicle" name="carrier" [(ngModel)]="item.carrier"
              appendTo="body" (change)="onCarrierChange($event)">
              <option value="-">-</option>
              <option *ngFor="let type of this.carriers" [value]="type.name">{{ type.name }}</option>
              <option value="other">Other</option>
            </select>
          </td> -->
          <td>
            <label class="modal-label">Veículo Solicitado*</label>
            <select [disabled]="!isAdminEnabled && !isUserEnabled" id="reqVehicle" name="reqVehicle"
              [(ngModel)]="item.reqVehicle" class="modal-select" (blur)="onFieldTouched()">
              <option value="-">-</option>
              <option *ngFor="let vehicle of typesVehicles" [value]="vehicle">{{ vehicle }}</option>
            </select>
            <div
              *ngIf="campoTocado && (item.reqVehicle == null || item.reqVehicle == undefined || item.reqVehicle == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td>
            <label class="modal-label">Placa do Veículo</label>     
            <input [disabled]="!isAdminEnabled && !isCarrierEnabled" type="text" name="plate" [(ngModel)]="item.plate"
              class="modal-input1">
          </td>
        </tr>
        <tr>
          <td class="selectStatus">
            <label class="modal-label">Nome do requisitante*</label>
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="reqName" (blur)="onFieldTouched()"
              [(ngModel)]="item.reqName" class="modal-input0">
            <div *ngIf="campoTocado && (item.reqName == null || item.reqName == undefined || item.reqName == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td class="selectStatus">
            <label class="modal-label">Usuário*</label>
            <!-- </td>
          <td class="selectStatus"> -->
            <input [disabled]="!isAdminEnabled" type="text" name="reqId" [(ngModel)]="item.reqId" class="modal-input1"
              (blur)="onFieldTouched()">
            <div *ngIf="campoTocado && (item.reqId == null || item.reqId == undefined || item.reqId == '')">
              <small class="text-danger">Required {{ item.reqId }}</small>
            </div>
          </td>
          <td class="selectStatus">
            <label class="modal-label">E-mail*</label>
            <!-- </td>
          <td class="align-left selectStatus"> -->
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="reqEmail"
              [(ngModel)]="item.reqEmail" class="modal-input0" (blur)="onFieldTouched()">
            <div *ngIf="campoTocado && (item.reqEmail == null || item.reqEmail == undefined || item.reqEmail == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td class="selectStatus">
            <label class="modal-label">Contato*</label>
            <!-- </td>
          <td class="input-maior selectStatus"> -->
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="reqPhone"
              [(ngModel)]="item.reqPhone" class="modal-input1" (blur)="onFieldTouched()">
            <div *ngIf="campoTocado && (item.reqPhone == null || item.reqPhone == undefined || item.reqPhone == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
        </tr>
        <tr>
          <td class="selectStatus">
            <label class="modal-label">E-mail do Gestor</label>
            <!-- </td>
          <td class="selectStatus"> -->
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="supEmail"
              [(ngModel)]="item.supEmail" class="modal-input1">
          </td>
          <td class="selectStatus">
            <label class="modal-label">Centro de Custo*</label>
            <!-- </td>
          <td class="selectStatus"> -->
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="costCenter"
              [(ngModel)]="item.costCenter" class="modal-input1" (blur)="onFieldTouched()">
            <div
              *ngIf="campoTocado && (item.costCenter == null || item.costCenter == undefined || item.costCenter == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td class="selectStatus">
            <label class="modal-label">Numero do Projeto</label>
            <!-- </td>
          <td class="selectStatus"> -->
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="projectNumber"
              [(ngModel)]="item.projectNumber" class="modal-input1">
          </td>
          <td class="selectStatus">
            <label class="modal-label">Numero da OS</label>
            <!-- </td>
          <td class="selectStatus"> -->
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="text" name="orderNumber"
              [(ngModel)]="item.orderNumber" class="modal-input1">
          </td>
        </tr>
        <td>
          <h3 class="modal-title">Informações de coleta</h3>
        </td>
        <tr>
          <td class="selectStatus">
            <label class="modal-label">Local de coleta*</label>
            <select [disabled]="!isAdminEnabled && !isUserEnabled" class="selectVehicle" name="locationPickup"
              [(ngModel)]="item.locationPickup" appendTo="body" (blur)="onFieldTouched()"
              (ngModelChange)="onFieldChanged('locationPickup', $event); verificaContato( $event)">
              <option *ngFor="let type of this.placesOrigin" [value]="type">{{ type }}</option>
              <option value="other">Other</option>
            </select>
            <div
              *ngIf="campoTocado && (item.locationPickup == null || item.locationPickup == undefined || item.locationPickup == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td class="selectStatus"
            *ngIf="item.locationPickup == 'SCANIA SBC' || item.locationPickup == 'Scania SLA' || item.locationPickup == 'SCANIA LATIN AMERICA - SLA' || item.locationPickup == 'SCANIA LATIN AMERICA - LCB'">
            <label class="modal-label">Área</label>
            <input type="text" name="areaPickup" placeholder="Ex.: P27-05" [(ngModel)]="item.areaPickup"
              class="modal-input1">
          </td>
          <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
            <label class="modal-label">Nome da Empresa</label>
            <input type="text" name="otherLocationPickup" [(ngModel)]="item.otherLocationPickup" class="modal-input1">
          </td>

          <td class="selectStatus">
            <label class="modal-label">Nome do contato</label>
            <input type="text" name="contatoPickup" [(ngModel)]="item.contatoPickup" class="modal-input1">
          </td>
          <td class="selectStatus">
            <label class="modal-label">Telefone</label>
            <input type="text" name="telefonePickup" [(ngModel)]="item.telefonePickup" class="modal-input1">
          </td>
        </tr>
        <tr>
          <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
            <form>
              <label class="modal-label" for="cepPickup">CEP*:</label>
              <input class="modal-input1" type="text" id="cepPickup" name="cepPickup" [(ngModel)]="item.cepPickup"
                (blur)="buscarEndereco()" required>
            </form>
            <div *ngIf="campoTocado && (item.cepPickup == null || item.cepPickup == undefined || item.cepPickup == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td class="selectStatus enderecoCompleto">
            <label class="modal-label">Endereço</label>
            <input type="text" name="addressPickup" [(ngModel)]="item.addressPickup" class="modal-input1"
              (blur)="onFieldTouched()">
            <div
              *ngIf="campoTocado && (item.addressPickup == null || item.addressPickup == undefined || item.addressPickup == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>

          <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
            <label class="modal-label">Numero</label>
            <input type="text" name="numberPickup" [(ngModel)]="item.numberPickup" class="modal-input1"
              (blur)="onFieldTouched()">
            <div
              *ngIf="campoTocado && (item.numberPickup == null || item.numberPickup == undefined || item.numberPickup == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>

          <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
            <label class="modal-label">Cidade</label>
            <input type="text" name="cityPickup" [(ngModel)]="item.cityPickup" class="modal-input1">
            <div
              *ngIf="campoTocado && (item.cityPickup == null || item.cityPickup == undefined || item.cityPickup == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td class="selectStatus" *ngIf="item.locationPickup == 'other'">
            <label class="modal-label">Estado</label>
            <input type="text" name="statePickup" [(ngModel)]="item.statePickup" class="modal-input1">
          </td>
        </tr>

        <tr>
          <td class="selectStatus">
            <label class="modal-label">Data da Coleta*</label>
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="date" name="datePickup"
              [(ngModel)]="item.datePickup" class="modal-input1" (blur)="onFieldTouched()">
            <div
              *ngIf="campoTocado && (item.datePickup == null || item.datePickup == undefined || item.datePickup == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td class="input-maior selectStatus">
            <label class="modal-label">Horário de Coleta*</label>                  
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="time" name="timePickup"
              [(ngModel)]="item.timePickup" class="modal-input1" (blur)="onFieldTouched()">
            <div
              *ngIf="campoTocado && (item.timePickup == null || item.timePickup == undefined || item.timePickup == '')">
              <small class="text-danger">Required</small>
            </div> 
          </td>
        </tr>
        <td>
          <h3 class="modal-title">Informações de entrega</h3>
        </td>
        <tr>
          <td class="selectStatus">
            <label class="modal-label">Local de entrega*</label>
            <select [disabled]="!isAdminEnabled && !isUserEnabled" class="selectVehicle" name="locationDelivery"
              [(ngModel)]="item.locationDelivery" appendTo="body" (blur)="onFieldTouched()"
              (ngModelChange)="onFieldChanged('locationDelivery', $event); verificaContatoEntrega( $event)">
              <option *ngFor="let typeDelivey of this.placesOrigin" [value]="typeDelivey">{{ typeDelivey}}
              </option>
              <option value="other">Other</option>
            </select>
            <div
              *ngIf="campoTocado && (item.locationDelivery == null || item.locationDelivery == undefined || item.locationDelivery == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td class="selectStatus"
            *ngIf="item.locationDelivery == 'SCANIA SBC' || item.locationDelivery == 'Scania SLA' || item.locationDelivery == 'SCANIA LATIN AMERICA - SLA' || item.locationDelivery == 'SCANIA LATIN AMERICA - LCB'">
            <label class="modal-label">Área</label>
               <input type="text" name="areaDelivery" placeholder="Ex.: P27-05" [(ngModel)]="item.areaDelivery"
              class="modal-input1">
          </td>
          <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
            <label class="modal-label">Nome da Empresa</label>
            <input type="text" name="otherLocationDelivery" [(ngModel)]="item.otherLocationDelivery"
              class="modal-input1">
          </td>

          <td class="selectStatus">
            <label class="modal-label">Nome do contato</label>
            <input type="text" name="contatoDelivery" [(ngModel)]="item.contatoDelivery" class="modal-input1">
          </td>
          <td class="selectStatus">
            <label class="modal-label">Telefone</label>
            <input type="text" name="telefoneDelivery" [(ngModel)]="item.telefoneDelivery" class="modal-input1">
          </td>
        </tr>


        <tr>
          <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
            <form>
              <label class="modal-label" for="cepDelivery">CEP*:</label>
              <input class="modal-input1" type="text" id="cepDelivery" name="cepDelivery" [(ngModel)]="item.cepDelivery"
                (blur)="buscarEnderecoEntrega()" required>
            </form>
            <div
              *ngIf="campoTocado && (item.cepDelivery == null || item.cepDelivery == undefined || item.cepDelivery == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td class="selectStatus enderecoCompleto">
            <label class="modal-label">Endereço</label>
            <input type="text" name="addressDelivery" [(ngModel)]="item.addressDelivery" class="modal-input1"
              (blur)="onFieldTouched()">
            <div
              *ngIf="campoTocado && (item.addressDelivery == null || item.addressDelivery == undefined || item.addressDelivery == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>

          <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
            <label class="modal-label">Numero</label>
            <input type="text" name="numberDelivery" [(ngModel)]="item.numberDelivery" class="modal-input1"
              (blur)="onFieldTouched()">
            <div
              *ngIf="campoTocado && (item.numberDelivery == null || item.numberDelivery == undefined || item.numberDelivery == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>

          <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
            <label class="modal-label">Cidade</label>
            <input type="text" name="cityDelivery" [(ngModel)]="item.cityDelivery" class="modal-input1">
            <div
              *ngIf="campoTocado && (item.cityDelivery == null || item.cityDelivery == undefined || item.cityDelivery == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td class="selectStatus" *ngIf="item.locationDelivery == 'other'">
            <label class="modal-label">Estado</label>
            <input type="text" name="stateDelivery" [(ngModel)]="item.stateDelivery" class="modal-input1">
          </td>
        </tr>

        <tr>
          <td class="selectStatus">
            <label class="modal-label">Data de entrega*</label>
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="date" name="dateDelivery"
              [(ngModel)]="item.dateDelivery" class="modal-input1" (blur)="onFieldTouched()">
            <div
              *ngIf="campoTocado && (item.dateDelivery == null || item.dateDelivery == undefined || item.dateDelivery == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
          <td class="input-maior selectStatus">
            <label class="modal-label">Horário de Entrega*</label>
            <input [disabled]="!isAdminEnabled && !isUserEnabled" type="time" name="timeDelivery"
              [(ngModel)]="item.timeDelivery" class="modal-input1" (blur)="onFieldTouched()">
            <div
              *ngIf="campoTocado && (item.timeDelivery == null || item.timeDelivery == undefined || item.timeDelivery == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <label class="modal-label">Observações</label>
            <input type="text" name="notes" [(ngModel)]="item.notes" class="modal-input0">
          </td>
          <td>
            <label class="modal-label">Item Crítico?</label>
            <input type="checkbox" id="critical">
          </td>
          <td>
            <label class="modal-label">Produto Perigoso?</label>
            <input type="checkbox" id="dangerousProduct">
          </td>
          <td>
            <label class="modal-label">Tipo</label>
            <mat-radio-group aria-label="tipo" [(ngModel)]="item.tipo" name="tipo" id="tipo" class="selectProdutivo">
              <label style="color:rgb(197, 196, 196)" class="modal-label">Produtivo</label>
              <mat-radio-button style="color:rgb(197, 196, 196)" value="produtivo"></mat-radio-button>
              <label style="color:rgb(197, 196, 196)" class="modal-label">Indireto</label>
              <mat-radio-button style="color:rgb(197, 196, 196)" value="indireto"></mat-radio-button>
            </mat-radio-group>
            <div *ngIf="campoTocado && (item.tipo == null || item.tipo == undefined || item.tipo == '')">
              <small class="text-danger">Required</small>
            </div>
          </td>
        </tr>
      </table>
      <div class="modal-div">
        <button class="modal-button" type="button" (click)="salvar(item)">Save</button>
        <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>